
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","aria-label":"Docker","role":"img","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"512","height":"512","rx":"15%","fill":"rgba(255,255,255,0)"}}),_c('path',{attrs:{"stroke":"#066da5","stroke-width":"38","d":"M296 226h42m-92 0h42m-91 0h42m-91 0h41m-91 0h42m8-46h41m8 0h42m7 0h42m-42-46h42"}}),_c('path',{attrs:{"fill":"#066da5","d":"m472 228s-18-17-55-11c-4-29-35-46-35-46s-29 35-8 74c-6 3-16 7-31 7H68c-5 19-5 145 133 145 99 0 173-46 208-130 52 4 63-39 63-39"}})])
          )
        }
      }
    